if ( objects.is_page_histoire ) {

    var controller = new ScrollMagic.Controller();
    var tl = new TimelineMax();

    // var scene = new ScrollMagic.Scene({
    //     triggerElement: "#timeline",
    //     triggerHook: 0,
    //     offset: -40,
    //     duration: "15%"
    // })
    // // .addIndicators({
    // //     colorTrigger: "green",
    // //     colorStart: "green",
    // //     colorEnd: "green",
    // //     indent: 5
    // // })
    // .setPin("#timeline")
    // .addTo(controller);


    tl.staggerTo(jQuery('.h-100-custom'), 0.2, {height:'100%', ease:Linear.easeNone}, 0.2);
    tl.call(check_line);

    var scene = new ScrollMagic.Scene({
        triggerElement: "#timeline",
        triggerHook: "onEnter",
        offset: 100,
        reverse: false
    })
    // .addIndicators({
    //     colorTrigger: "white",
    //     colorStart: "white",
    //     colorEnd: "white",
    //     indent: 5
    // })
    .setTween(tl)
    .addTo(controller);

    // check_line();

    // jQuery(window).on('scroll', function() {
    //     check_line();
    // });

    function check_line() {
        jQuery(".line-l-date").each(function (index, elem) {
            // setTimeout(function() {
                var tl = new TimelineMax();
                var line_height = jQuery('#line_l_' + index).parent()[0].style.height;
                line_height = line_height.replace('%','');

                if ( line_height > 20 ) {
                    tl.to(CSSRulePlugin.getRule('#line_l_' + index + ':after'), 1, { cssRule: {width: 100} });
                } else {
                    tl.to(CSSRulePlugin.getRule('#line_l_' + index + ':after'), 0.2, { cssRule: {width: 0} });
                }
            // }, 200);
        });

        jQuery(".line-r-date").each(function (index, elem) {
            // setTimeout(function() {
                var tl = new TimelineMax();
                var line_height = jQuery('#line_r_' + index).parent()[0].style.height;
                line_height = line_height.replace('%','');

                if ( line_height > 20 ) {
                    tl.to(CSSRulePlugin.getRule('#line_r_' + index + ':after'), 1, { cssRule: {width: 100} });
                } else {
                    tl.to(CSSRulePlugin.getRule('#line_r_' + index + ':after'), 0.2, { cssRule: {width: 0} });
                }
            // }, 200);
        });
    }

}